import React, { useState, useEffect } from "react";
// import "../admissionAlert.css";
import "../css/admissionAlert.css"

export default function AdmissionAlert() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 3000); // 3 second delay

    return () => clearTimeout(timer);
  }, []);

  // 👇 Ye function missing tha (error yahi se aa raha tha)
  const closeAlert = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="admission-alert">
      <div className="alert-box">
        <button className="close-btn" onClick={closeAlert}>×</button>
{/* 
        <h2>Admission Alert</h2>
        <p>Admissions are now open. Register now!</p> */}
        <div className="admision-alert-img">

        <img src="../img/admision-alert/admission-alrt.webp" alt="sanskar school admission open" />
        </div>
        <a href="https://erp.sanskarjaipur.com/Reg/Terms?ins=OTA1YWVlOTktMjM3ZS00MjI2LThmMjAtZjMxNmVjMGRmZGRjNzg3OA==&amp;br=MjRkZTdhYjgtZTI5OC00MTNiLTg0YzAtNzdiMjUzMzYwNzQ2Nzg3OA==&amp;session=2026" className="alert-btn">Register now</a>
      </div>
    </div>
  );
}
